import { Pipe, PipeTransform } from '@angular/core';

import { Filters, Sorts } from '@/models/pipes';
import { Punk } from '@/models/graph';

@Pipe({
  standalone: true,
  name: 'sort'
})

export class SortPipe implements PipeTransform {

  transform(value: Punk[], ...args: [Sorts, Filters]): Punk[] {

    // console.log('sort pipe', {value, args});

    if (!value?.length) return [];
    if (!args?.length) return value;

    const activeSort = args[0];
    const marketTYype = args[1];

    let sorted = [ ...value ];

    if (activeSort === 'price-low') {
      if (marketTYype === 'listings' || marketTYype === 'nftx-vault') sorted = value.sort((a: Punk, b: Punk) => Number(a.listing?.value || '0') - Number(b.listing?.value || '0'));
      if (marketTYype === 'bids') sorted = value.sort((a: Punk, b: Punk) => Number(a.bid?.value || '0') - Number(b.bid?.value || '0'));
    }

    if (activeSort === 'price-high') {
      if (marketTYype === 'listings' || marketTYype === 'nftx-vault') sorted = value.sort((a: Punk, b: Punk) => Number(b.listing?.value || '0') - Number(a.listing?.value || '0'));
      if (marketTYype === 'bids') sorted = value.sort((a: Punk, b: Punk) => Number(b.bid?.value || '0') - Number(a.bid?.value || '0'));
    }

    if (activeSort === 'recent') {
      // console.log(args)
      if (marketTYype === 'listings' || marketTYype === 'nftx-vault') sorted = value.sort((a: Punk, b: Punk) => Number(b.listing?.blockTimestamp || '0') - Number(a.listing?.blockTimestamp || '0'));
      if (marketTYype === 'bids') sorted = value.sort((a: Punk, b: Punk) => Number(b.bid?.blockTimestamp || '0') - Number(a.bid?.blockTimestamp || '0'));
    }

    if (activeSort === 'id') {
      sorted = value.sort((a: Punk, b: Punk) => Number(a.id) - Number(b.id));
    }

    return sorted;
  }
}
